
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/saquon",
      function () {
        return require("private-next-pages/saquon.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/saquon"])
      });
    }
  